export default "__VITE_ASSET__BWjfcf3___"